import { DcpProductType, EngineRequestDtoTypeEnum } from '@dh-io-pls/pls-ui-types';
import { CUSTOMER_TYPE, configurationProductProductGroup } from '@sccs/types';
import {
  array,
  boolean,
  nullish,
  number,
  object,
  optional,
  picklist,
  string,
  unknown,
  enum as valibotEnum,
} from 'valibot';

const DcpProductTypeSchema = object({
  name: string(),
});

const CustomerTypeSchema = valibotEnum(CUSTOMER_TYPE);

const CustomerSchema = object({
  type: optional(CustomerTypeSchema),
  segmentId: optional(number()),
});

const VehicleConfigurationSchema = object({
  division: optional(string()),
  brand: optional(string()),
  baumuster: optional(string()),
  nst: optional(nullish(string())),
  modelYear: optional(string()),
  onlineSalesFlag: optional(string()),
});

const ConditionSchema = object({
  condition: string(),
});

const PriceInfoSchema = object({
  id: string(),
  currency: optional(string()),
  rawValue: optional(number()),
  charges: optional(array(unknown())),
});

const AmountInfoSchema = object({
  rawRate: optional(number()),
  rawAmount: optional(number()),
  type: optional(string()),
});

const VehicleSchema = object({
  vehicleConfiguration: optional(VehicleConfigurationSchema),
  additionalValues: optional(array(AmountInfoSchema)),
  condition: optional(ConditionSchema),
  technicalIdReference: optional(string()),
  name: optional(string()),
  prices: optional(array(PriceInfoSchema)),
  financialCode: optional(string()),
  vdzDeal: optional(boolean()),
});

export const FcisWidgetParametersSchema = object({
  caller: string(),
  market: string(),
  locale: string(),
  vehicle: optional(VehicleSchema),
  vehicleId: optional(string()),
  productCode: optional(string()),
  customer: optional(CustomerSchema),
  dcpProductType: optional(DcpProductTypeSchema),
});

const ProductBadgeSchema = object({
  description: optional(string()),
  footnote: optional(string()),
  name: optional(string()),
});

const ProductPriceSchema = object({
  value: number(),
  formattedValue: string(),
});

const DcpPriceProductTypeSchema = valibotEnum(DcpProductType);

export const StockProductSchema = object({
  code: string(),
  dcpProductType: optional(
    object({
      name: DcpPriceProductTypeSchema,
    }),
  ),
  price: optional(ProductPriceSchema),
  listPrice: optional(ProductPriceSchema),
  badges: optional(array(ProductBadgeSchema)),
  productCategory: optional(string()),
  isUsed: optional(boolean()),
});

const EngineRequestDtoTypeEnumSchema = valibotEnum(EngineRequestDtoTypeEnum);

const WltpEmissionSchema = object({
  total: optional(number()),
  weighted: optional(number()),
});

const WltpRangeSchema = object({
  totalAll: optional(number()),
  totalEquivalentAll: optional(number()),
});

const WltpSchema = object({
  emission: optional(WltpEmissionSchema),
  range: optional(WltpRangeSchema),
});

const DriveCycleSchema = object({
  wltp: optional(WltpSchema),
});

const EngineRequestSchema = object({
  type: EngineRequestDtoTypeEnumSchema,
  driveCycle: DriveCycleSchema,
});

const TechnicalDataSchema = object({
  co2EmissionTotalCombined: optional(number()),
  fuelConsumptionTotalCombined: optional(number()),
  engine: optional(EngineRequestSchema),
});

export const ConfigurationProductSchema = object({
  vehicleId: string(),
  offeringLocation: optional(string()),
  productGroup: picklist(configurationProductProductGroup),
  basePriceAmount: optional(number()),
  totalOptionPriceAmount: optional(number()),
  configurationPriceAmount: optional(number()),
  discountablePriceAmount: optional(number()),
  technicalData: optional(TechnicalDataSchema),
});
